import React from "react";
import { Dispatcher } from "../../../flux";
import OverleafStore, {
  TYPE_IMAGE,
  TYPE_TEXT
} from "../../../../../stores/overleaf-store";
import { Isvg } from "../../../components";
import { VstLoader, VstDropdown } from "vstui";
import Template from "./template";
import Card from "./card";
import AccessibleSearchResults from "../../../../accessability/accessibleSearchResults";
import { getEmptyCard } from "../types";
import styled from "styled-components";
import { FilterKnobs } from "@vitalsource/vstui-icons";
import { Button } from "@vitalsource/vstui";

const Styled = {
  // With a separate positional container the aria-expanded gets added to the
  // containing div instead of the actual button. This can be cleaned up when
  // we switch out VstDropdown for the new Popover. Similarly, VstPopover does
  // not provide a good way to trigger the change in fill except via direct css
  FilterButton: styled(Button)`
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    &.open {
      cursor: pointer;
      svg {
        fill: ${props => props.theme.vstui.color.secondary.getShade(5)};
      }
    }
  `
};

export default class Deck extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      deck: null,
      confidence: false,
      searchedCards: []
    };
    this._closeFiguresPanel = this._closeFiguresPanel.bind(this);
    this._getDeck = this._getDeck.bind(this);
    this.toggleHigh = this._toggleProficiency.bind(this, 1);
    this.toggleLow = this._toggleProficiency.bind(this, -1);
    this.toggleAll = this._toggleProficiency.bind(this, false);
  }

  componentDidMount() {
    this._getDeck(Object.assign({}, this.props, { focusOnHeader: true }));
    Dispatcher.bind(Dispatcher.OVERLEAF_CHANGE, this._getDeck);
    $(window).bind("mouseup touchup", this._mouseUp);
  }

  componentWillUnmount() {
    Dispatcher.unbind(Dispatcher.OVERLEAF_CHANGE, this._getDeck);
    $(window).unbind("mouseup touchup", this._mouseUp);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.findValue !== nextProps.findValue) {
      const searchedCards = this._searchCards(nextProps.findValue);
      this.setState({ searchedCards });
    }

    if (nextProps.uuid !== this.props.uuid) {
      this._getDeck(nextProps);
    }
  }

  _closeFiguresPanel() {
    Dispatcher.emit(Dispatcher.TOGGLE_PANEL, "flashcards");
  }

  _getDeck(props) {
    const { uuid, findValue, focusOnHeader } = props || this.props;
    return OverleafStore.getDeck(uuid).then(deck => {
      if (focusOnHeader && deck.cards.length > 0) {
        document.getElementById("header-button").focus();
      }
      this.setState({ deck, searchedCards: this._searchCards(findValue) });
    });
  }

  renderCards() {
    const { deck, searchedCards, confidence } = this.state;
    const { adding, uuid, findValue, isbn } = this.props;
    const cards = findValue ? searchedCards : deck.cards;
    if (cards.length > 0 || adding) {
      this.proficiencyFilteredCards = cards.reduce((acc, card) => {
        const con = card.confidence;
        if (!confidence || con === confidence) {
          acc.push(
            <Card
              key={`card-${card.uuid}`}
              cancel={this.props.cancel}
              card={card}
              isbn={isbn}
            />
          );
        }
        return acc;
      }, []);
      if (this.proficiencyFilteredCards.length > 0 || adding) {
        return (
          <ul id="cards">
            {adding && (
              <Template
                front={this.props.newCardFront || getEmptyCard()}
                cancel={this.props.cancel}
                deckUUID={uuid}
                isbn={isbn}
              />
            )}
            {this.proficiencyFilteredCards}
          </ul>
        );
      }
      return (
        <div className="try-other-filter">
          {i18n.t("reader.flashcards.try-diff-filter")}
        </div>
      );
    } else {
      return (
        <div className="try-other-filter">
          {i18n.t("reader.flashcards.try-diff-search")}
        </div>
      );
    }
  }

  _searchCards(findValue) {
    const { deck } = this.state;
    const value = findValue.toLowerCase();

    function matches(info) {
      if (info.type === TYPE_TEXT) {
        return info.content.toLowerCase().indexOf(value) !== -1;
      } else if (info.type === TYPE_IMAGE) {
        const desc = `${info.metadata.title || ""} ${info.metadata.caption ||
          ""}`;
        return desc.toLowerCase().indexOf(value) !== -1;
      }
      return false;
    }

    return deck
      ? deck.cards.filter(card => {
          return matches(card.front) || matches(card.back);
        })
      : [];
  }

  _toggleProficiency(confidence) {
    this.setState(prevState => {
      return { confidence: confidence };
    });
  }

  renderFlashCardsButton() {
    return (
        <Styled.FilterButton
          iconStart={<FilterKnobs />}
          label={i18n.t("flashcards.filter-deck")}
          color="neutral"
          naked
        />
    );
  }

  renderNullScreenContainer() {
    return (
      <div className="null-screen-container">
        <div className="null-screen">
          {Fraction.Brand.Graphics.watkins && (
            <Isvg className="watkins null" src="/img/watkins_search.svg" />
          )}
          <h3 className="title">
            {i18n.t("reader.flashcards.nothing-here-yet")}
          </h3>
          <p className="instructions">
            {i18n.t("reader.flashcards.use-button-deck")}
          </p>
        </div>
      </div>
    );
  }

  renderCardsContainer() {
    const { confidence } = this.state;
    let allPressed = !confidence;
    let lowPressed = confidence === -1;
    let highPressed = confidence === 1;

    const filteredCards = this.renderCards();
    const cardCount = i18n.t("reader.flashcards.card-count", {
      amount: this.props.findValue
        ? this.state.searchedCards.length
        : this.proficiencyFilteredCards.length
    });
    
    return (
      <div id="cards-container">
        <div className="card-count-filter">
          <div className="card-count">
            <AccessibleSearchResults result={cardCount}/>
          </div>
          <VstDropdown
            className="panel-confidence-filter"
            vertical={"bottom"}
            horizontal={"right"}
            target={this.renderFlashCardsButton()}
            headerTitle={i18n.t("flashcards.filter")}
          >
            <VstDropdown.Item role="subheader">
              {i18n.t("flashcards.filter")}
            </VstDropdown.Item>
            <VstDropdown.Item onClick={this.toggleAll} selected={allPressed}>
              <div className="panel-confidence-item all">
                <span>{i18n.t("flashcards.all")}</span>
              </div>
            </VstDropdown.Item>
            <VstDropdown.Item onClick={this.toggleLow} selected={lowPressed}>
              <div className="panel-confidence-item dont-know">
                <span>{i18n.t("reader.flashcards.dont-know-it")}</span>
              </div>
            </VstDropdown.Item>
            <VstDropdown.Item
              onClick={this.toggleHigh}
              selected={highPressed}
            >
              <div className="panel-confidence-item know-it">
                <span>{i18n.t("reader.flashcards.know-it")}</span>
              </div>
            </VstDropdown.Item>
          </VstDropdown>
        </div>
        <div className="cards-inner-container">{filteredCards}</div>
      </div>
    );
  }

  renderBodyContent() {
    const { deck } = this.state;
    const { adding } = this.props;
    if (!deck) {
      return (
        <VstLoader />
      );
    } else if (deck.cards.length > 0 || adding) {
      return this.renderCardsContainer();
    } else {
      return this.renderNullScreenContainer();
    }
  }

  render() {
    return (
      <div id="deck-cards">
        {this.renderBodyContent()}
      </div>
    );
  }
}

Deck.defaultProps = {
  back: ""
};
